import React, { useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../context/ThemeContext';

const { FiSearch, FiX, FiSun, FiMoon } = FiIcons;

const SearchBar = ({ query, onQueryChange }) => {
  const inputRef = useRef(null);
  const { theme, toggleTheme } = useTheme();

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleClear = () => {
    onQueryChange('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleChange = (e) => {
    onQueryChange(e.target.value);
  };

  return (
    <div className="sticky top-0 z-30 bg-inherit py-4 -mt-2">
      <form onSubmit={handleSubmit} className="flex items-center gap-2 max-w-4xl mx-auto sm:mx-0">
        <div className="relative flex-1">
          <SafeIcon
            icon={FiSearch}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 transform text-gray-400 dark:text-gray-500"
          />
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={handleChange}
            placeholder="Search all fields (name, notes, nicknames, etc)..."
            className="w-full rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-2.5 pl-10 pr-3 text-gray-900 dark:text-white shadow-sm transition-all focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/10 dark:focus:ring-blue-500/20"
          />
        </div>
        <button
          type="button"
          onClick={handleClear}
          disabled={!query}
          className="inline-flex items-center gap-1 rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 py-2.5 text-sm font-semibold text-gray-600 dark:text-gray-400 shadow-sm transition-all hover:bg-gray-50 dark:hover:bg-slate-700 hover:text-blue-600 dark:hover:text-blue-400 disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="Clear search"
        >
          <SafeIcon icon={FiX} />
          <span className="hidden sm:inline">Clear</span>
        </button>
        <button
          type="button"
          onClick={toggleTheme}
          className="p-2.5 rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-gray-600 dark:text-gray-400 shadow-sm transition-all hover:bg-gray-50 dark:hover:bg-slate-700 hover:text-blue-600 dark:hover:text-blue-400"
          title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
        >
          <SafeIcon icon={theme === 'light' ? FiMoon : FiSun} size={20} />
        </button>
      </form>
    </div>
  );
};

export default SearchBar;